import React from 'react';
import ContactLinkItem from './ContactLinkItem';
import { Grid } from '@mui/material';

const RecommendedLinks = ({ onContactLinkButtonClick }) => {
    const items = ['Email', 'Call', 'LinkedIn', 'Website'];

    return (
        <Grid container spacing={1} sx={{ justifyContent: 'flex-start' }}>
            {items.map((item) => (
                <Grid item xs={6} key={item}> {/* Adjusted to 6 for two items per row */}
                    <ContactLinkItem 
                        text={item} 
                        onClick={() => onContactLinkButtonClick(item)} 
                        type={item} 
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default RecommendedLinks;